module.exports = __webpack_public_path__ + "19201cb65e6c5c5938c3d7aafc073c.png";